import { render, staticRenderFns } from "./NeedContractorReviewModal.vue?vue&type=template&id=2038d050&scoped=true&"
import script from "./NeedContractorReviewModal.vue?vue&type=script&lang=js&"
export * from "./NeedContractorReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./NeedContractorReviewModal.vue?vue&type=style&index=0&id=2038d050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038d050",
  null
  
)

export default component.exports